import React, { useState } from 'react'
import './color-palette-panel.less'
import { Tooltip } from 'antd';

import { ReactComponent as PaletteSvg } from './palette.svg';

const colorList = [
    '#000000', '#f8d731', '#cd6928', '#991b1e', '#642165', '#293189', '#22346e', '#136734', '#727430',
    '#636466', '#f1eb1f', '#f26722', '#cd2027', '#93278f', '#4554a5', '#105689', '#139b48', '#999b37',
    '#939598', '#f4ee51', '#f8991e', '#ed1f24', '#a953a0', '#5e67af', '#2776bb', '#58ba48', '#c8c92d',
    '#c7c8ca', '#f7f281', '#fecc66', '#f27172', '#d19cc7', '#9898cc', '#7aafdf', '#afd9aa', '#e5e878',
    '#ffffff', '#f8f6b0', '#feeab9', '#f7abae', '#ddb3d4', '#cecce6', '#adddf7', '#d7ebd2', '#edee99',
];
const indexColorList = [
    '#ff0000',
    '#ffff00',
    '#00ff00',
    '#00ffff',
    '#0000ff',
    '#ff00ff',
    '#ffffff',
    '#808080',
    '#c0c0c0',
];

const HexStringToKeywords = {
    '#ff0000': '红',
    '#ffff00': '黄',
    '#00ff00': '绿',
    '#00ffff': '青',
    '#0000ff': '蓝',
    '#ff00ff': '洋红',
    '#ffffff': '白',
    '#808080': '8',
    '#c0c0c0': '9',
};

interface IProps {
    onColorClick?: (value: string) => void
    onModalClick?: () => void
}

/**
 * 调色盘
 * @returns 
 */
export default function ColorPalettePanel(props: IProps) {

    
    
    return (
        <div className='color-palette-drop-container'>
            <div className="color-select">
                <div className="color-wrapper">
                    {colorList.map((color, idx) => (
                        <Tooltip title={color} key={idx} overlayClassName="color-tooltip">
                            <div className="color-item" onClick={() => props.onColorClick?.(color)}>
                                <div className="color-box" style={{ backgroundColor: color }}></div>
                            </div>
                        </Tooltip>
                    ))}
                </div>
            </div>
            <div className="divider"></div>
            <div className="color-select">
                <div>索引颜色</div>
                <div className="color-wrapper">
                    {indexColorList.map((color, idx) => (
                        <Tooltip title={HexStringToKeywords[color] || color} key={idx} overlayClassName="color-tooltip">
                            <div className="color-item" onClick={() => props.onColorClick?.(color)}>
                                <div className="color-box" style={{ backgroundColor: color }}></div>
                            </div>
                        </Tooltip>
                    ))}
                </div>
            </div>
            <div className="divider"></div>
            <div className="click-select" style={{ marginTop: '4px' }} onClick={() => {
                props.onModalClick?.();
            }}>
                <PaletteSvg className='click-icon'/>
                <span>更多颜色...</span>
            </div>

        </div>
    )
}
